export function SupportIcon() {
  return (
    <svg width="68" height="59" viewBox="0 0 68 59" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M38.7084 0.625C22.763 0.625 9.83337 13.5546 9.83337 29.5H0.208374L12.6888 41.9804L12.9134 42.4296L25.875 29.5H16.25C16.25 17.0837 26.2921 7.04167 38.7084 7.04167C51.1246 7.04167 61.1667 17.0837 61.1667 29.5C61.1667 41.9162 51.1246 51.9583 38.7084 51.9583C32.5163 51.9583 26.9017 49.4238 22.8592 45.3492L18.3034 49.905C23.533 55.1346 30.7196 58.375 38.7084 58.375C54.6538 58.375 67.5834 45.4454 67.5834 29.5C67.5834 13.5546 54.6538 0.625 38.7084 0.625ZM35.5 16.6667V32.7083L49.2317 40.8575L51.5417 36.9754L40.3125 30.3021V16.6667H35.5Z"
        fill="black" />
    </svg>

  );
}